import React, { memo } from "react";
import useHeader from "./index.hooks";
import { Link } from "react-router-dom";
import {
  AppBar,
  Container,
  Box,
  Divider,
  Hidden,
  IconButton,
  List,
  ListItem,
  SwipeableDrawer,
  Toolbar,
  Slide,
} from "@material-ui/core";
import appLogo from "assets/images/logo.png";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { LanguageMenu, AppButton } from "../index";

type HeaderProps = {};

const navigationLinks = [
  { _id: "home", name: "Home", path: "/" },
  { _id: "how", name: "Come Funziona", path: "/howitworks" },
  // { _id: "prices", name: "Prezzi", path: "/services" },
];

const Header = ({}: HeaderProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    isSwipeableDrawerOpen,
    handleSwipeableDrawerOpen,
    handleSwipeableDrawerClose,
    handleGoToSection,
    handleDrawerItemSelection,
    trigger,
    t,
  } = useHeader();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      <AppBar position="fixed" color="primary">
        <Container className={styles.rootContainer} maxWidth="lg">
          <Toolbar disableGutters>
            <Box className={styles.logoContainer}>
              <img
                src={appLogo}
                alt="logo"
                className={styles.logo}
                onClick={() => handleGoToSection("home")}
              />
            </Box>
            <LanguageMenu />
            <Hidden smDown>
              {navigationLinks.map((link) => (
                <Box
                  key={link._id}
                  className={styles.link}
                  onClick={() => handleGoToSection(link._id)}
                >
                  {
                    // @ts-ignore
                    t(link.name)
                  }
                </Box>
              ))}
              <Link className={styles.link} to="/faq">
                FAQs
              </Link>
              <AppButton isCta path="/signup/">
                {t("Registrati")}
              </AppButton>
            </Hidden>
            <Hidden mdUp>
              <IconButton onClick={handleSwipeableDrawerOpen}>
                <MenuIcon className={styles.menuIcon} />
              </IconButton>
            </Hidden>
          </Toolbar>
        </Container>
        <SwipeableDrawer
          anchor="right"
          open={isSwipeableDrawerOpen}
          onOpen={handleSwipeableDrawerOpen}
          onClose={handleSwipeableDrawerClose}
          classes={classes.swipeableDrawerMenu}
        >
          <div>
            <IconButton onClick={handleSwipeableDrawerClose}>
              <ChevronRightIcon className={styles.menuIcon} />
            </IconButton>
          </div>
          <Divider />
          <List>
            {navigationLinks.map((link) => (
              <ListItem key={link._id}>
                <Box
                  onClick={() => handleDrawerItemSelection(link._id)}
                  className={styles.link}
                >
                  {
                    // @ts-ignore
                    t(link.name)
                  }
                </Box>
              </ListItem>
            ))}
            <ListItem>
              <Link
                onClick={handleSwipeableDrawerClose}
                className={styles.link}
                to="/faq"
              >
                FAQs
              </Link>
            </ListItem>
            <ListItem>
              <AppButton
                isCta
                path="/signup/"
                onClick={handleSwipeableDrawerClose}
              >
                {t("Registrati")}
              </AppButton>
            </ListItem>
          </List>
        </SwipeableDrawer>
      </AppBar>
    </Slide>
  );
};

export default memo(Header);
